import React, { Suspense } from "react";
import { HashRouter as BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";
import { AuthProvider } from "./contexts";
import { AdminRouter } from "./router/AdminRouter";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useLocaleStore } from "./store/localeStore";
import {
  ThemeRuntimeProvider,
  RouteScopeWatcher,
} from "./ui/theme/ThemeRuntimeProvider";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const antdLocaleMap = {
  es: esES,
  en: enUS,
};

export default function App() {
  const locale = useLocaleStore((s) => s.locale);

  return (
    <ConfigProvider locale={antdLocaleMap[locale] ?? esES}>
      <ThemeRuntimeProvider>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <AuthProvider>
            <Suspense fallback={<div>Loading...</div>}>
              <BrowserRouter future={{ v7_startTransition: true }}>
                <RouteScopeWatcher />
                <Routes>
                  <Route path="/*" element={<AdminRouter />} />
                  <Route path="/portal/*" element={<AdminRouter />} />
                </Routes>
              </BrowserRouter>
            </Suspense>
          </AuthProvider>
        </GoogleOAuthProvider>
      </ThemeRuntimeProvider>
    </ConfigProvider>
  );
}
